import { convertDuration } from '@helpers/convertDuration';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { JobResponseDto } from 'app/API';
import { JOB_STATUSES_ENUM } from 'app/types/enums/jobStatuses';

export const JOBS_LIST_CSV_HEADERS = [
  'ID',
  'Title',
  'Due',
  'Assignee',
  'Organization',
  'Workspace',
  'Status',
  'Created',
  'Tags',
  'Duration',
  'Edits %',
];

export type TJobsListCsvSource = Pick<
  JobResponseDto,
  | 'id'
  | 'name'
  | 'deadline'
  | 'assignee'
  | 'draftAssignee'
  | 'status'
  | 'createdAt'
  | 'tags'
  | 'duration'
  | 'editingProgress'
>;

type TContext = {
  organizationName: string;
  workspaceName: string;
};

export const buildJobsListCsvRows = (jobs: TJobsListCsvSource[], { organizationName, workspaceName }: TContext) =>
  jobs.map((job) => {
    const assignee = job?.assignee || job?.draftAssignee;
    return {
      id: job.id,
      title: job.name,
      due: job.deadline ? getAmericanTime(job.deadline, false) : '',
      assignee: assignee ? `${assignee.name} ${assignee.lastname} (${assignee.email})` : '',
      organization: organizationName,
      workspace: workspaceName,
      status: JOB_STATUSES_ENUM[job.status as keyof typeof JOB_STATUSES_ENUM],
      created: getAmericanTime(job.createdAt),
      tags: (job.tags ?? []).join(', '),
      duration: convertDuration(job.duration ?? 0),
      editsPercent: Math.round(job.editingProgress || 0),
    };
  });
